function initDropdown(){
	let dropdowns = [...document.getElementsByClassName("dropdown")];
	dropdowns.forEach(function(dropdown){
		if(!dropdown.classList.contains("dropdown__initParsed")){
			dropdown.tabIndex = 0;
			dropdown.classList.add("dropdown__initParsed");
			let select = dropdown.getElementsByTagName('select')[0];
			let selectSelected = document.createElement("div");
			let dropdownInput = document.createElement("input");
			let closeDropdown = function (){
				if(!document.activeElement.classList.contains('dropdown__input') && !document.activeElement.classList.contains('dropdown') && dropdown.classList.contains('dropdown--active')){	
					let options = [...document.getElementsByClassName("dropdown__options")];
					options.forEach(function(option){
						option.classList.remove("dropdown__options--hide");
					});
					dropdownInput.value='';
					dropdown.classList.remove("dropdown--active");
				}
			}
			dropdownInput.setAttribute("autocomplete","off");
			dropdownInput.classList.add("dropdown__input");
			dropdownInput.addEventListener("keyup",function(){
				if(dropdownInput.value.trim().length>0){
					let options = [...document.getElementsByClassName("dropdown__options")];
					let newOptions = [];
					let invalidIndex = 100000000000;
					options.forEach(function(option){
						newOptions[newOptions.length] = {
							index: (option.innerHTML.trim().toUpperCase().search(dropdownInput.value.trim().toUpperCase())==-1)? invalidIndex:option.innerHTML.toUpperCase().search(dropdownInput.value.toUpperCase()),
							opt:option 
						}
						invalidIndex++;
					});
					newOptions.sort((a, b) => (a.opt.innerHTML < b.opt.innerHTML) ? 1 : -1)
					newOptions.sort((a, b) => (a.index > b.index) ? 1 : -1)
					newOptions.forEach(function(option){
						option.opt.parentNode.appendChild(option.opt);
					})
				}
			});
			window.addEventListener("click",function(){
				closeDropdown(event);
			})
			select.dataset.parsed="true";
			selectSelected.classList.add("dropdown__selected");
			selectSelected.innerHTML = select.options[select.selectedIndex].innerHTML;
			dropdown.append(selectSelected);
			dropdown.append(dropdownInput);
			let selectOptionWrapper = document.createElement("div");
			selectOptionWrapper.classList.add("dropdown__options-wrapper");
			selectSelected.addEventListener("click", function(){
				dropdown.classList.toggle("dropdown--active");
				dropdownInput.focus();
			});
			for(let j=0;j<select.options.length;j++){
				let selectOption = document.createElement("div");
				selectOption.classList.add("dropdown__options");
				selectOption.innerHTML = select.options[j].innerHTML;
				selectOption.addEventListener("click",function(){
					let select = dropdown.getElementsByTagName("select")[0];
					let selectSelected = selectOption.parentNode.parentNode.getElementsByClassName("dropdown__selected")[0];
					let options = selectOption.parentNode.getElementsByClassName("dropdown__options");
					for(let i=0;i<options.length;i++){
						if(selectOption==options[i]){
							selectSelected.innerHTML = selectOption.innerHTML;
							select.selectedIndex = i;
							selectOption.parentNode.parentNode.classList.remove("dropdown--active");
							select.dispatchEvent(new Event("change"));
						}
					}
				});
				selectOptionWrapper.append(selectOption);
			}
			dropdown.append(selectOptionWrapper);
		}
	});
}
export default{
	initDropdown
}